interface ModalEscolhaPreliminarEtapa3Props {
  assessorNome?: string;
  onManterVoto: () => void;
  onCarregarVoto: () => void;
}

/**
 * Modal de escolha exibido ao VP quando existe um voto preliminar do assessor
 * E o VP já tem um voto/rascunho próprio (conflito). Layout dedicado: botões
 * empilhados e o detalhamento resumido no rodapé.
 */
export function ModalEscolhaPreliminarEtapa3({
  assessorNome,
  onManterVoto,
  onCarregarVoto,
}: ModalEscolhaPreliminarEtapa3Props) {
  return (
    <div className="bg-white rounded-lg">
      <div className="p-4">
        <h3 className="text-black-bb text-[26px] md:text-[32px] font-title font-bold">
          Voto preparado por: {assessorNome}
        </h3>
        {/* {assessorNome && (
          <p className="mt-1 text-base text-[#2C323F]">
            Preparado por <strong>{assessorNome}</strong>.
          </p>
        )} */}
      </div>

      <div className="flex flex-col gap-3 px-4">
        <button
          type="button"
          onClick={onCarregarVoto}
          className="w-full bg-yellow-bb text-blue-bb-1 rounded-[4px] text-sm font-title uppercase py-3 px-4 font-bold"
        >
          Carregar voto do(a) assessor(a)
        </button>
        <button
          type="button"
          onClick={onManterVoto}
          className="w-full bg-[#E0E9FF] text-blue-bb-1 rounded-[4px] text-sm font-title uppercase py-3 px-4 font-bold"
        >
          Manter meu voto
        </button>
      </div>

      <p className="px-4 pb-4 pt-3 text-sm text-gray-bb-2 leading-relaxed">
       Ao carregar o voto do(a) Assessor(a), você substituirá a votação já iniciada, porém ainda poderá revisar e editar antes de enviar o voto final.
      </p>
    </div>
  );
}

export default ModalEscolhaPreliminarEtapa3;
